module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi5-83a7b6db37c9ee5125beb2b9d7f27333.png";